export { MyPosMiniPlugin } from './plugin';
